import { string } from "@src/libs/yup";

export default string()
	.min(10, "Phone must be at least 10 digits")
	.phone("Phone is invalid")
	.required("Please enter a phone number");
